import { HeroOffer } from '@itau-loans-www/components'

const Hero = ({ proposal }) => {
  return <HeroOffer proposal={proposal} />
}

export default Hero
